// extracted by mini-css-extract-plugin
export default {"cover":"_2KZ0K"};